import { ShiftCardWrapper } from "../../Shift/Card/Wrapper";
import { VisitCardContent } from "../Card/Content";
import { type PatientData, type VisitWithCaseData } from "../types";

interface InHomeVisitBookingCardProps {
  visit: VisitWithCaseData;
  patient: PatientData | undefined;
  specialties: string[];
  workplaceName: string;
}

export function InHomeVisitBookingCard(props: InHomeVisitBookingCardProps) {
  const { visit, patient, specialties, workplaceName } = props;

  return (
    <ShiftCardWrapper sx={{ width: "100%" }}>
      <VisitCardContent
        visit={visit}
        patient={patient}
        specialties={specialties}
        workplaceName={workplaceName}
      />
    </ShiftCardWrapper>
  );
}
